export default __webpack_public_path__ + "static/thumb-landscape-3b0424cc1c2a3ed0a8b26c37c9936fff.webp";